import { get, groupBy } from 'lodash';
import {
  createActions,
  createReqConsts,
  createReqReducer,
  createReqWatcher,
  initialState as requestInitialState,
} from '../../utils/redux';

import { consts as flushCounterConstants } from './removeNotificationsCounters';
import { ACTIVITY_TYPES } from '../../constants';

const paginationInitialState = {
  member: {
    offset: 0,
    limit: 10,
  },
  moderator: {
    offset: 0,
    limit: 10,
  },
};

const metaInitialState = {
  [ACTIVITY_TYPES.NOTIFICATIONS]: {
    offset: 0,
    limit: 10,
    total: 0,
  },
  [ACTIVITY_TYPES.JOIN_REQUESTS]: {
    offset: 0,
    limit: 10,
    total: 0,
  },
  [ACTIVITY_TYPES.MEMBER_INVITATIONS]: {
    offset: 0,
    limit: 10,
    total: 0,
  },
};

const initialState = {
  ...requestInitialState,
  pagination: paginationInitialState,
  meta: metaInitialState,
  [ACTIVITY_TYPES.NOTIFICATIONS]: [],
  [ACTIVITY_TYPES.JOIN_REQUESTS]: [],
  [ACTIVITY_TYPES.MEMBER_INVITATIONS]: [],
};

const request = {
  endpoint: 'activity_notifications',
  type: 'get',
  slug: [
    {
      type: 'payload.query',
      queryParameter: 'subject_type',
      selector: 'type',
    },
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
};

export const consts = createReqConsts(
  'communities',
  'communitiesJoinRequests',
  [
    'REMOVE_REQUEST',
    'DISABLE_REQUEST',
    'PAGE_LEAVE',
    'RESET_IS_NEW_FLAG',
    'REAL_TIME_INSERT',
  ],
);
export const paginatedConsts = createReqConsts(
  'communities',
  'communitiesPaginatedJoinRequests',
  ['LOAD_NEXT_REQUESTS', 'UPDATE_PAGINATION_PARAMETERS'],
);

export const actions = createActions(consts);
export const paginatedActions = createActions(paginatedConsts);

export const watcher = createReqWatcher(consts, actions, request);
export const paginatedWatcher = createReqWatcher(
  paginatedConsts,
  paginatedActions,
  request,
);

const defaultRequestReducer = createReqReducer(consts);

function setNewStatus(list) {
  return list.map(item => ({
    ...item,
    isNew: item.status === 'unread',
  }));
}

export default (state = initialState, action) => {
  const { payload } = action;

  switch (action.type) {
    case consts.SUCCEED: {
      return Object.assign(
        {},
        state,
        requestInitialState,
        {
          succeed: true,
        },
        groupBy(setNewStatus(payload), 'type'),
      );
    }
    case paginatedConsts.SUCCEED: {
      const group = groupBy(payload, 'type');
      const type = Object.keys(group)[0] || ACTIVITY_TYPES.NOTIFICATIONS;
      const list = get(group, type, []);
      const prevList = get(state, type, []);

      return Object.assign({}, state, requestInitialState, {
        succeed: true,
        [type]: prevList.concat(setNewStatus(list)),
      });
    }

    case consts.ADD_META: {
      const type = payload.subjectType;
      const prevMetaByType = get(state, ['meta', type]);

      return {
        ...state,
        meta: {
          ...state.meta,
          [type]: {
            ...prevMetaByType,
            total: payload.count,
          },
        },
      };
    }

    case consts.REAL_TIME_INSERT: {
      const { type, list } = payload;

      const prevList = get(state, type, []);
      const prevMetaByType = get(state, ['meta', type]);

      return {
        ...state,
        [type]: [...setNewStatus(list), ...prevList],
        meta: {
          ...state.meta,
          [type]: {
            ...prevMetaByType,
            total: get(prevMetaByType, 'total', 0) + list.length,
          },
        },
      };
    }

    case flushCounterConstants.SEND: {
      const { meta, notificationIds } = payload;
      const list = get(state, meta, []).map(item => {
        return notificationIds.includes(item.id)
          ? { ...item, status: 'read' }
          : { ...item };
      });

      return {
        ...state,
        [meta]: [...list],
      };
    }

    case consts.RESET_IS_NEW_FLAG: {
      const { ids, type } = payload;
      const list = get(state, type, []).map(item => {
        return ids.includes(item.id) ? { ...item, isNew: false } : { ...item };
      });

      return {
        ...state,
        [type]: [...list],
      };
    }

    case paginatedConsts.UPDATE_PAGINATION_PARAMETERS: {
      const { type, offset, limit } = payload;
      const prevMetaByType = get(state, ['meta', type]);

      return {
        ...state,
        meta: {
          ...state.meta,
          [type]: {
            ...prevMetaByType,
            offset,
            limit,
          },
        },
      };
    }

    case consts.REMOVE_REQUEST: {
      const { type, id } = action.payload;
      const prevList = get(state, type, []);
      const list = prevList.filter(item => get(item, 'subject.id') !== id);
      const prevMetaByType = get(state, ['meta', type]);

      return {
        ...state,
        [type]: list,
        meta: {
          ...state.meta,
          [type]: {
            ...prevMetaByType,
            total: get(prevMetaByType, 'total', 0) - 1,
          },
        },
      };
    }

    case consts.DISABLE_REQUEST: {
      const { id, type } = action.payload;
      const prevList = get(state, type, []);
      const list = prevList.map(item => {
        return get(item, 'subject.id') === id
          ? { ...item, disabled: true }
          : item;
      });

      return {
        ...state,
        [type]: list,
      };
    }
    default: {
      return defaultRequestReducer(state, action);
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/communities/communitiesJoinRequests.js